import { CONSTANT } from '../../../constant/constant';
import { ENDPOINTS } from '../../../constant/endpoints';
import {
    generalHttpGetRequest,
    generalHttpPostRequest,
    generalHttpPutRequest
} from '../../../helper/request-helper';

const fetchUsersUrl = CONSTANT.baseUrl + ENDPOINTS.employee.user.fetchUsers;
const fetchUserUrl = CONSTANT.baseUrl + ENDPOINTS.employee.user.fetchUser;
const addNewUserUrl = CONSTANT.baseUrl + ENDPOINTS.employee.user.addNewUser;
const updateUserUrl = CONSTANT.baseUrl + ENDPOINTS.employee.user.updateUser;

export const actionType = {
    REQUESTED_USER_DATA: 'REQUESTED_USER_DATA',
    REJECTED_USER_DATA: 'REJECTED_USER_DATA',
    FETCH_USER: 'FETCH_USER',
    FETCH_USERS: 'FETCH_USERS',
    UPDATE_USER_SELECTED: 'UPDATE_USER_SELECTED',
    ADD_NEW_USER: 'ADD_NEW_USER',
    EDIT_USER: 'EDIT_USER',
    UPDATE_ADD_NEW_USER_PAYLOAD: 'UPDATE_ADD_NEW_USER_PAYLOAD',
    UPDATE_EDIT_USER_PAYLOAD: 'UPDATE_EDIT_USER_PAYLOAD'
};

export const fetchUsers = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_USER_DATA
        });

        return generalHttpGetRequest(fetchUsersUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_USERS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_USER_DATA,
                    data: error
                });
            });
    };
};

export const fetchUserData = userId => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_USER_DATA
        });

        return generalHttpGetRequest(fetchUserUrl + userId)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_USER,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_USER_DATA,
                    data: error
                });
            });
    };
};

export const updateUserSelected = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_USER_SELECTED,
            payload: selected
        });
    };
};

export const addNewUser = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_USER_DATA
        });

        return generalHttpPostRequest(addNewUserUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.ADD_NEW_USER,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_USER_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const editUser = payload => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_USER_DATA
        });

        return generalHttpPutRequest(updateUserUrl, payload)
            .then(response => {
                dispatch({
                    type: actionType.EDIT_USER,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_USER_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const updateAddNewUserPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_ADD_NEW_USER_PAYLOAD,
            payload: selected
        });
    };
};

export const updateEditUserPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_EDIT_USER_PAYLOAD,
            payload: selected
        });
    };
};


// WEBPACK FOOTER //
// ./src/services/redux/employee/user/actions.js